// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Chip, useWatch } from '@metarouter-private/mr-mui';

import { isPipelineComplete } from '../confirmUpdateFormModel';

/**
 * A per-row "needs attention" indicator for the confirm-update data-table. It
 * subscribes to its own pipeline's live form values via useWatch and derives
 * completeness from the shared predicate — it does NOT validate (no trigger),
 * so it never sets RHF errors. Because only current-page rows mount, the watch
 * cost stays bounded regardless of how many pipelines are selected.
 */
export default function RequiresAttentionCell({ pipelineId, requiredVariableNames, consentCategoryEnabled }) {
  const pipelineValues = useWatch({ name: pipelineId }) || {};

  if (isPipelineComplete(pipelineValues, { requiredVariableNames, consentCategoryEnabled })) {
    return null;
  }

  return <Chip size="small" color="warning" label="Needs values" data-test-id={`requiresAttention-${pipelineId}`} />;
}

RequiresAttentionCell.propTypes = {
  pipelineId: PropTypes.string.isRequired,
  requiredVariableNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  consentCategoryEnabled: PropTypes.bool.isRequired,
};
